export default __webpack_public_path__ + "static/media/MOON.919a4307.png";